module.exports = __webpack_public_path__ + "media/images/decorations/decoration-3-56f0b3d8c3db2412f475826e32953145.svg";